import React, { createContext, useContext, useEffect, useState } from "react"

const TokenContext = createContext()

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    try {
      const storedToken = localStorage.getItem("accessToken")
      if (storedToken) {
        setToken(storedToken)
      }
    } finally {
      setLoading(false)
    }
  }, [])

  return (
    <TokenContext.Provider value={{ token, setToken, loading }}>
      {children}
    </TokenContext.Provider>
  )
}

export const useToken = () => useContext(TokenContext)
